import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=3f3aff2e&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"
import "./Inquiry.vue?vue&type=style&index=0&id=3f3aff2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3aff2e",
  null
  
)

export default component.exports